// src/views/SSOTransfer/SSOTransferView.tsx

import { useEffect } from 'react';
import { handleSSOTransfer } from '@/domains/auth/utils/ssoTransfer';

const SSOTransferView = () => {
  useEffect(() => {
    handleSSOTransfer();
  }, []);

  return null;
};

export default SSOTransferView;
